import { ContractState } from '../../../../types/ContractMessage';
import { Tag } from '../../../cdl/Tag/Tag';
import { translate } from '../../../common/helpers/translate.helper';

const variantMap: Record<ContractState, 'default' | 'accent' | 'positive'> = {
    DRAFT: 'default',
    AWARDED: 'accent',
    ACTIVE: 'positive',
    INACTIVE: 'default',
};

const statusTranslationMap = (status: ContractState) => {
    switch (status) {
        case ContractState.DRAFT:
            return translate('contracts.status.DRAFT');

        case ContractState.AWARDED:
            return translate('contracts.status.AWARDED');

        case ContractState.ACTIVE:
            return translate('contracts.status.ACTIVE');

        case ContractState.INACTIVE:
            return translate('contracts.status.INACTIVE');
    }
};

interface ContractStatusTagProps {
    status: ContractState;
}

export const ContractStatusTag = ({ status }: ContractStatusTagProps) => {
    return <Tag variant={variantMap[status]}>{statusTranslationMap(status)}</Tag>;
};
